import Dexie, { type EntityTable } from 'dexie';
import type { Book } from './schema';

const bookDb = new Dexie('BookDatabase') as Dexie & {
    books: EntityTable<Book, 'bookName'>;
};

bookDb.version(1).stores({
    books: 'bookName, children, gdocs',
});

export { bookDb };
